module.exports = __webpack_public_path__ + "static/media/Selected.7e9045a3.svg";